import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styles from "./crf.module.css";
import { get, post, _delete } from "util/requests";
import Segment from "ui/crfs/segment";
import { cloneDeep } from "lodash";
import { useLocation } from "react-router-dom";
import router from "routes";
import moment from "moment";
import NotificationWindow from "ui/crfs/notification_widget/components/notification_window";
import { renderFieldComponent } from "ui/crfs/segment/helpers";

const arrayHaveCommonItems = (arr1, arr2) => {
  if (arr1 && arr1.constructor === Array && arr2 && arr2.constructor === Array) {
    return arr1.some((item) => arr2.includes(item));
  } else return false;
};

export default function CrfForm(props) {
  const {
    crf_id,
    subject_id,
    domain_id,
    visit_index,
    updateCrfQueryStatus,
    updateCrfStatus,
    updateCrfFlags,
    form_type,
    multi_entry_crf_id = null,
    site_id,
    fetchSidebarData,
    crfFlags = null,
  } = props;
  const location = useLocation();
  const [crf_data, setCrfData] = useState(null);
  const [sae_adjudication_data, setSaeAdjudicationData] = useState(null);
  const [sae_medra_data, setSaeMedraData] = useState(null);
  const [crfStatus, setCrfStatus] = useState(null);
  const [crfSignStatus, setCrfSignStatus] = useState(null);
  const [showingDataCompleteMakeChangeModal, setShowingDataCompleteMakeChangeModal] = useState(false);
  const [queryModalData, setQueryModalData] = useState(null);

  const permissions = useSelector((state) => state.user.userData.permissions);
  const user_domains = useSelector((state) => state.user.userData.domains);
  const study_id = useSelector((state) => state.study.active_study_id);

  let linked_sae_adjudication_crf_id = null;
  let linked_sae_medra_crf_id = null;

  useEffect(() => {
    if (form_type === "multi_entry") {
      if (crf_id !== "adverse_events") {
        get(`/subject_multi_entry_crf_data/${subject_id}/${props.crf_id}/${multi_entry_crf_id}`).then((ret) => {
          setCrfData({ ...ret.data, multi_entry_crf_id });
          setCrfStatus(ret.data.status || "");
          setCrfSignStatus(ret.data.qc_status || []);
          updateCrfFlags(props.crf_id, ret.data, "multi_entry", multi_entry_crf_id);
          post("/footprint", {
            path: location.pathname,
            action: "pageload",
            name: `crf-${ret.data.name}`,
            subject_id,
            study_id,
            site_id,
          });
        });
      } else {
        get(`/subject_multi_entry_crf_data/${subject_id}/${props.crf_id}/${multi_entry_crf_id}`).then((ret) => {
          setCrfData({ ...ret.data, multi_entry_crf_id });
          setCrfStatus(ret.data.status || "");
          // setSaeAdjudicationData(sae_adjudication_ret.data);
          // setSaeMedraData(sae_medra_ret.data);
          setCrfSignStatus(ret.data.qc_status || []);
          post("/footprint", {
            path: location.pathname,
            action: "pageload",
            name: `crf-${ret.data.name}`,
            subject_id,
            study_id,
            site_id,
          });

          linked_sae_adjudication_crf_id = ret.data.linked_sae_adjudication_crf_id || crypto.randomUUID();
          linked_sae_medra_crf_id = ret.data.linked_sae_medra_crf_id || crypto.randomUUID();

          get(`/subject_multi_entry_crf_data/${subject_id}/sae_adjudication/${linked_sae_adjudication_crf_id}`).then(
            (sae_adjudication_ret) => {
              if (sae_adjudication_ret.data?.read_permission || sae_adjudication_ret.data?.write_permission) {
                setSaeAdjudicationData({
                  ...sae_adjudication_ret.data,
                  multi_entry_crf_id: linked_sae_adjudication_crf_id,
                });
              } else {
                setSaeAdjudicationData({});
              }
            }
          );

          get(`/subject_multi_entry_crf_data/${subject_id}/sae_medra/${linked_sae_medra_crf_id}`).then(
            (sae_medra_ret) => {
              if (sae_medra_ret.data?.read_permission || sae_medra_ret.data?.write_permission) {
                setSaeMedraData({
                  ...sae_medra_ret.data,
                  multi_entry_crf_id: linked_sae_medra_crf_id,
                });
              } else {
                setSaeMedraData({});
              }
            }
          );
        });
      }
    } else {
      get(`/subject_crf_data/${subject_id}/${props.crf_id}`)
        .then((ret) => {
          if (["no_domain_access", "no_site_access"].includes(ret.data.status)) {
            router.navigate("/subjects");
            return;
          }
          setCrfData(ret.data);
          setCrfStatus(ret.data.status || "");
          setCrfSignStatus(ret.data.qc_status || []);
          post("/footprint", {
            path: location.pathname,
            action: "pageload",
            name: `crf:${ret.data.name}`,
            subject_id,
            study_id,
            site_id,
          });
        })
        .catch(() => {
          router.navigate("/subjects");
        });
    }
  }, [crf_id, subject_id, multi_entry_crf_id]);

  const deleteForm = () => {
    return new Promise((resolve) => {
      let params = {};

      _delete(`/mutli_entry_crf/${subject_id}/${props.crf_id}/${multi_entry_crf_id}`, { name: crf_data.name }).then(
        () => {
          resolve();
          fetchSidebarData();
        }
      );
    });
  };

  const setQuery = (crf_id, field_id, query) => {
    let data = cloneDeep(crf_data);
    let fields = data.design.fields;
    let field = fields.find((f) => f.id === field_id);
    field.query = query;
    setCrfData(data);
  };

  const resolveCrfDataObject = (multi_entry_crf_id, _crf_data) => {
    if (!multi_entry_crf_id) {
      _crf_data = { ...crf_data };
      setCrfSignStatus([]);
    } else if (multi_entry_crf_id === crf_data.multi_entry_crf_id) {
      _crf_data = { ...crf_data };
      setCrfSignStatus([]);
    } else if (multi_entry_crf_id === sae_adjudication_data.multi_entry_crf_id) {
      _crf_data = { ...sae_adjudication_data };
    } else if (multi_entry_crf_id === sae_medra_data.multi_entry_crf_id) {
      _crf_data = { ...sae_medra_data };
    }
    return _crf_data;
  };

  const updateFieldValue =
    (field_id, field_type, crf_id, multi_entry_crf_id = null, linked_crf_id = null, question_text = "") =>
    (value_obj) => {
      post("/crf_data", {
        crf_id,
        field_id,
        value_obj,
        patient_id: subject_id,
        study_id: study_id,
        field_type,
        form_type,
        multi_entry_crf_id,
        pathname: location.pathname,
        domain_id,
        timezone: moment.tz.guess(),
        crf_slug: crf_data.slug,
        visit_index,
        linked_crf_id,
        question_text,
      }).then(({ data }) => {
        let _crf_data = null;
        _crf_data = resolveCrfDataObject(multi_entry_crf_id, _crf_data);

        let field = _crf_data.design.fields.find((field) => field.id === field_id);
        field.value_obj = value_obj;
        field.value_obj.data_id = data.data_id;
        // if (data.deviation_object && data.deviation_object.deviation === true) {
        //   field.value_obj.deviation = true;
        // } else {
        //   delete field.value_obj.deviation;
        //   delete field.value_obj.violation;
        // }

        // if (data.deviation_object.auto_query) {
        //   field.query = data.deviation_object.auto_query;
        // }

        new Promise((resolve) => {
          if (arrayHaveCommonItems(field.value_obj?.flags || [], ["monitored", "qa", "site_signoff"])) {
            let post_flags = [];

            if (field.value_obj?.flags.includes("monitored")) {
              post_flags.push("remonitored");
              field.value_obj?.flags.push("remonitored");
            }
            if (field.value_obj?.flags.includes("qa")) {
              post_flags.push("reqa");
              field.value_obj?.flags.push("reqa");
            }
            if (field.value_obj?.flags.includes("site_signoff")) {
              post_flags.push("resite_signoff");
              field.value_obj?.flags.push("resite_signoff");
            }

            post("/crf_data_flag", {
              data_id: field.value_obj.data_id,
              flag: post_flags,
              subject_id,
              study_id,
              is_add: true,
            }).then((ret) => {
              let flags = [...ret.data.flags];
              resolve();
            });
          } else {
            resolve();
          }
        }).then(() => {
          //process related fields for calculations that are not the field that was posted
          let calculation_fields = _crf_data.design.fields.filter(
            (f) =>
              parseInt(f.id) !== parseInt(field_id) &&
              f.calculated &&
              f.calculation.constructor === Array &&
              f.calculation.length &&
              f.calculation.filter((cf) => cf.calc_type === "add_field" && parseInt(cf.value) === parseInt(field_id))
                .length
          );

          calculation_fields.forEach((cf) => {
            let calculated_value = 0;
            let calculate_require_all_data = cf.calculate_require_all_data;
            let all_fields_have_data = true;
            cf.calculation.forEach((calc_field) => {
              if (calc_field.calc_type === "initial_value") {
                calculated_value = parseInt(calc_field.value);
              } else if (calc_field.calc_type === "add_field") {
                let target_field = _crf_data.design.fields.find((f) => parseInt(f.id) === parseInt(calc_field.value));
                let value_obj_value = target_field.value_obj?.value;
                let options = target_field.options;

                let field_value = 0;
                if (value_obj_value && target_field.type === "select") {
                  field_value = target_field.options.reduce((accum, options_obj) => {
                    if (value_obj_value.includes(options_obj.value)) {
                      accum = accum + parseInt(options_obj.score);
                    }
                    return accum;
                  }, 0);
                } else if (value_obj_value && target_field.type === "radio") {
                  field_value = parseInt(
                    target_field.options.find(
                      (o) => parseInt(o.value) === parseInt(value_obj_value) || o.value === value_obj_value
                    ).score
                  );
                } else if (!value_obj_value) {
                  all_fields_have_data = false;
                }
                calculated_value += field_value;
                cf.value_obj.value = calculated_value;
              }
            });
            if (calculate_require_all_data && !all_fields_have_data) {
              cf.value_obj.value = null;
            }
            post("/crf_data", {
              crf_id,
              field_id: cf.id,
              value_obj: cf.value_obj,
              patient_id: subject_id,
              study_id: study_id,
              field_type: cf.type,
              form_type,
              multi_entry_crf_id,
              pathname: location.pathname,
              domain_id,
              timezone: moment.tz.guess(),
              crf_slug: crf_data.slug,
              visit_index,
              linked_crf_id,
              question_text: "",
              calculated: true,
            });
          });

          if (!multi_entry_crf_id || multi_entry_crf_id === crf_data.multi_entry_crf_id) {
            setCrfData(_crf_data);
          } else if (multi_entry_crf_id === crf_data.multi_entry_crf_id) {
            setSaeAdjudicationData(_crf_data);
          }

          updateCrfFlags(crf_id, _crf_data, form_type, multi_entry_crf_id);
        });
      });
    };

  const updateFieldFlag =
    (data_id, field_id, crf_id, multi_entry_crf_id = null) =>
    (flag, is_add) => {
      let _crf_data = null;
      _crf_data = resolveCrfDataObject(multi_entry_crf_id, _crf_data);

      let field = _crf_data.design.fields.find((field) => field.id === field_id);
      let data_is_complete = renderFieldComponent(field, _crf_data.design.fields, {
        return_data_state_only: true,
        updateFieldFlag: () => () => {},
        crf_data,
        user_domains,
      });
      if (!data_is_complete && is_add) {
        return;
      }

      post("/crf_data_flag", {
        data_id,
        flag,
        subject_id,
        study_id,
        is_add,
      }).then((ret) => {
        let flags = [...ret.data.flags];

        field.value_obj.flags = flags;

        if (!multi_entry_crf_id || multi_entry_crf_id === crf_data.multi_entry_crf_id) {
          setCrfData(_crf_data);
        } else if (multi_entry_crf_id === crf_data.multi_entry_crf_id) {
          setSaeAdjudicationData(_crf_data);
        }

        updateCrfFlags(crf_id, _crf_data, form_type, multi_entry_crf_id);
      });
    };

  const batchUpdateFieldFlag =
    (data_ids, crf_id, multi_entry_crf_id = null) =>
    (flag, is_add, { reason = null, password = null }) => {
      if (data_ids.length) {
        return new Promise((resolve) => {
          post("/crf_data_flag", {
            data_id: data_ids,
            flag,
            subject_id,
            study_id,
            is_add,
            is_batch: true,
            password,
          })
            .then((ret) => {
              // let flags = [...ret.data.flags];
              // let _crf_data = cloneDeep(crf_data);
              //intentionally don't cloneDeep here
              let _crf_data = null;
              _crf_data = resolveCrfDataObject(multi_entry_crf_id, _crf_data);
              _crf_data.design.fields.forEach((field) => {
                if (data_ids.includes(field.value_obj?.data_id)) {
                  let flags = field.value_obj.flags || [];
                  if (is_add) {
                    flags.push(flag);
                  } else {
                    flags = flags.filter((f) => f !== flag);
                  }
                  flags = flags.filter((f) => f !== `re${flag}`);
                  field.value_obj.flags = Array.from(new Set(flags));
                }
              });

              if (!multi_entry_crf_id || multi_entry_crf_id === crf_data.multi_entry_crf_id) {
                setCrfData(_crf_data);
              } else if (multi_entry_crf_id === crf_data.multi_entry_crf_id) {
                setSaeAdjudicationData(_crf_data);
              }
              // //set the flags at the main crf level
              // if (is_add && previous_field_flags.filter((d) => !d.includes(flag)).length === 1) {
              //   ret.data.flags.push(`all_${flag}`);
              // } else if (!is_add && previous_field_flags.filter((d) => d.includes(flag)).length > 1) {
              //   ret.data.flags.push(flag);
              // }
              updateCrfFlags(crf_id, _crf_data, form_type, multi_entry_crf_id).then(() => resolve({ success: true }));
            })
            .catch(() => resolve({ success: false }));
        });
      } else {
        return Promise.resolve();
      }
    };

  //the query modal data was moved to an object at this level so that we are only dealing with one instance of the modal at a time
  const _setQueryModalData = (field) => {
    setQueryModalData({ ...field, showing: true, slug: crf_data.slug, crf_id: crf_data.crf_id });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.subject_title_wrapper}>
        <div className={styles.subject_title}>
          <strong>{props.subject_id}</strong>
        </div>
      </div>
      {crf_data?.site_name ? (
        <div className={styles.site_title2}>{`${crf_data?.site_name} (${crf_data?.site_code})`}</div>
      ) : (
        ""
      )}
      <div className={styles.segmentWrapper}>
        <Segment
          title={(crf_data && crf_data.name && crf_data.name.toUpperCase()) || ""}
          crf_id={crf_id}
          multi_entry_crf_id={multi_entry_crf_id}
          crf_data={crf_data}
          crf_status={crf_data?.status}
          crf_sign_status={crfSignStatus}
          subject_id={subject_id}
          setQueryModalData={_setQueryModalData}
          updateCrfStatus={(crf_id, status, multi_entry_crf_id) => {
            //this looks like some straight fuckery, but we maintain the status up a level so we can combine the actions on the crf with the actions on the crf list, like the setting of data state
            updateCrfStatus(crf_id, status, form_type, multi_entry_crf_id).then((status) => {
              let _crf_data = { ...crf_data };
              _crf_data.status = status;
              setCrfData(_crf_data);
            });
          }}
          updateCrfSignStatus={(crf_id, status, remove = false) => {
            let _status = [...crfSignStatus];
            let _crf_data = { ...crf_data };
            if (remove) {
              _status = _status.filter((s) => s !== status);

              _crf_data.qc_status = _crf_data.qc_status.filter((s) => s !== status);
            } else {
              _status.push(status);
              _crf_data.qc_status.push(status);
            }
            setCrfSignStatus(_status);
            setCrfData(_crf_data);
          }}
          showDeleteFormOption={form_type === "multi_entry" && crf_data?.write_permission}
          deleteForm={deleteForm}
          setQuery={setQuery}
          updateCrfQueryStatus={updateCrfQueryStatus}
          form_type={form_type}
          updateFieldValue={updateFieldValue}
          updateFieldFlag={updateFieldFlag}
          batchUpdateFieldFlag={batchUpdateFieldFlag}
          visit_index={visit_index}
          ignore_ref_height={true}
          crfFlags={crfFlags || crf_data?.flags}
        ></Segment>
        {crf_id === "adverse_events" &&
        sae_adjudication_data &&
        Object.keys(sae_adjudication_data)?.length &&
        crf_data?.design?.fields?.find((f) => f.id === 1)?.value_obj?.value === "yes" ? (
          <Segment
            title={
              (sae_adjudication_data && sae_adjudication_data.name && sae_adjudication_data.name.toUpperCase()) || ""
            }
            crf_id={"sae_adjudication"}
            multi_entry_crf_id={sae_adjudication_data?.multi_entry_crf_id}
            linked_crf_id={multi_entry_crf_id}
            crf_data={sae_adjudication_data}
            crf_status={sae_adjudication_data?.status}
            crf_sign_status={crfSignStatus}
            subject_id={subject_id}
            setQueryModalData={_setQueryModalData}
            updateCrfStatus={(crf_id, status, multi_entry_crf_id) => {
              //this looks like some straight fuckery, but we maintain the status up a level so we can combine the actions on the crf with the actions on the crf list, like the setting of data state
              updateCrfStatus("sae_adjudication", status, form_type, sae_adjudication_data?.multi_entry_crf_id).then(
                (status) => {
                  // setCrfStatus(status);
                  let _sae_adjudication_data = { ...sae_adjudication_data };
                  _sae_adjudication_data.status = status;
                  setSaeAdjudicationData(_sae_adjudication_data);
                }
              );
            }}
            updateCrfSignStatus={(crf_id, status) => {
              let _status = [...crfSignStatus];
              _status.push(status);
              setCrfSignStatus(_status);
            }}
            setQuery={setQuery}
            updateCrfQueryStatus={updateCrfQueryStatus}
            form_type={form_type}
            updateFieldValue={updateFieldValue}
            updateFieldFlag={updateFieldFlag}
            batchUpdateFieldFlag={batchUpdateFieldFlag}
            visit_index={visit_index}
            is_linked_crf={true}
            crfFlags={crfFlags}
          ></Segment>
        ) : null}
        {crf_id === "adverse_events" && sae_medra_data && Object.keys(sae_medra_data)?.length ? (
          <Segment
            title={(sae_medra_data && sae_medra_data.name && sae_medra_data.name.toUpperCase()) || ""}
            crf_id={"sae_medra"}
            multi_entry_crf_id={sae_medra_data?.multi_entry_crf_id}
            linked_crf_id={multi_entry_crf_id}
            crf_data={sae_medra_data}
            crf_status={sae_medra_data?.status}
            crf_sign_status={crfSignStatus}
            subject_id={subject_id}
            setQueryModalData={_setQueryModalData}
            updateCrfStatus={(crf_id, status, multi_entry_crf_id) => {
              //this looks like some straight fuckery, but we maintain the status up a level so we can combine the actions on the crf with the actions on the crf list, like the setting of data state
              updateCrfStatus(crf_id, status, form_type, multi_entry_crf_id).then((status) => {
                setCrfStatus(status);
              });
            }}
            updateCrfSignStatus={(crf_id, status, multi_entry_crf_id) => {
              let _status = [...crfSignStatus];
              _status.push(status);
              setCrfSignStatus(_status);
            }}
            setQuery={setQuery}
            updateCrfQueryStatus={updateCrfQueryStatus}
            form_type={form_type}
            updateFieldValue={updateFieldValue}
            updateFieldFlag={updateFieldFlag}
            batchUpdateFieldFlag={batchUpdateFieldFlag}
            visit_index={visit_index}
            is_linked_crf={true}
            crfFlags={crfFlags}
          ></Segment>
        ) : null}

        <div className={styles.protocol_vesion}>CRF Version {crf_data?.version}</div>
      </div>
      <NotificationWindow
        crf_name={crf_data?.name}
        data_name={queryModalData?.label}
        showing={queryModalData?.showing}
        closeNotificationWindow={() => setQueryModalData(null)}
        query={queryModalData?.query}
        crf_id={queryModalData?.crf_id}
        field_id={queryModalData?.id}
        subject_id={subject_id}
        domain_id={domain_id}
        visit_index={visit_index}
        setQuery={setQuery}
        calcUpdateToCrfStatus={updateCrfQueryStatus}
        currentValueDisplay={""}
        multi_entry_crf_id={multi_entry_crf_id}
        form_type={form_type}
        crf_slug={queryModalData?.slug}
      />
    </div>
  );
}
